import { render, staticRenderFns } from "./TransferProductCollapsableItem.vue?vue&type=template&id=ae40b47e&"
import script from "./TransferProductCollapsableItem.vue?vue&type=script&lang=js&"
export * from "./TransferProductCollapsableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports